export const KizViewInventorySvedPluginSettings: IPluginSettings = {
    name: 'КИЗ-ы',
    mnemocode: 'kiz_view_inventory_sved_plugin',
    columns: [
        //IDGLOBAL
        {
            order: 0,
            propertyName: 'idGlobal',
            propertyType: 'string',
            displayName: 'idGlobal',
            visibility: false,
            width: 100
        },
        //barcode
        {
            order: 1,
            propertyName: 'barcode',
            propertyType: 'string',
            displayName: 'Зашифрованный КИЗ',
            visibility: false,
            width: 100
        },
        //SGTIN
        {
            order: 2,
            propertyName: 'sGtin',
            propertyType: 'string',
            displayName: 'SGTIN',
            visibility: false,
            width: 100
        },
        //GTIN
        {
            order: 3,
            propertyName: 'gtin',
            propertyType: 'string',
            displayName: 'GTIN',
            visibility: false,
            width: 100
        },
        //GTIN SGTIN
        {
            order: 4,
            propertyName: 'gtinSGtin',
            propertyType: 'string',
            displayName: 'GTIN_SGTIN',
            visibility: true,
            width: 100
        },
        {
            order: 5,
            propertyName: 'kizState',
            propertyType: 'string',
            displayName: 'Статус КИЗ',
            visibility: true,
            width: 100
        },
        {
            order: 6,
            propertyName: 'decodedBarcode',
            propertyType: 'string',
            displayName: 'КИЗ',
            visibility: true,
            width: 100
        },
        {
            order: 7,
            propertyName: 'lotName',
            propertyType: 'string',
            displayName: 'Товар',
            visibility: true,
            width: 100
        },
        {
            order: 8,
            propertyName: 'code',
            propertyType: 'string',
            displayName: 'Код товара',
            visibility: false,
            width: 100
        },
        {
            order: 9,
            propertyName: 'docType',
            propertyType: 'string',
            displayName: 'Схема',
            visibility: false,
            width: 100
        },
        {
            order: 10,
            propertyName: 'idError',
            propertyType: 'string',
            displayName: 'Код ошибки',
            visibility: true,
            width: 100
        },
        {
            order: 11,
            propertyName: 'error',
            propertyType: 'string',
            displayName: 'Ошибка ГИС "Маркировка"',
            visibility: true,
            width: 100
        },
        {
            order: 12,
            propertyName: 'documentOutId',
            propertyType: 'string',
            displayName: 'ИД документа МДЛП',
            visibility: false,
            width: 150
        },
        {
            order: 13,
            propertyName: 'remain',
            propertyType: 'decimal',
            displayName: 'Остаток',
            visibility: true,
            width: 150
        },
    ]
}
